import { Button } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import type { TipMode } from "Components/Shared/TipSelector/types";

type Props = {
  mode: TipMode;
  label: string;
  isSelected: boolean;
  onClick: (mode: TipMode) => void;
};

export const TipButton = ({ mode, label, isSelected, onClick }: Props) => (
  <Button
    onClick={() => onClick(mode)}
    disableElevation
    sx={({ palette }) => ({
      flex: 1,
      height: 48,
      minWidth: 0,
      padding: "10px",
      borderRadius: "6px",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "20px",
      textTransform: "none",
      backgroundColor: isSelected ? palette.primary.main : palette.common.white,
      border: isSelected
        ? `1px solid ${palette.primary.main}`
        : `1px solid ${Colors.Border}`,
      color: isSelected ? palette.common.white : palette.common.black,
      "&:hover": {
        backgroundColor: isSelected
          ? palette.primary.dark
          : Colors.BackgroundGrey,
        border: isSelected
          ? `1px solid ${palette.primary.dark}`
          : `1px solid ${palette.primary.main}`,
      },
    })}
  >
    {label}
  </Button>
);
